var _path, _rect, _rect2, _path2, _rect3, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDesk = function SvgDesk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M3 8.5h14a.5.5 0 0 0 .5-.5V4.5h-15V8a.5.5 0 0 0 .5.5Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 5.25,
    y: 6,
    fill: "currentColor",
    rx: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 1,
    x: 12.75,
    y: 6,
    fill: "currentColor",
    rx: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M2 2.5h16a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V3a.5.5 0 0 1 .5-.5Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 1,
    x: 9.5,
    y: 8.5,
    fill: "currentColor",
    rx: 0.5,
    transform: "rotate(-90 9.5 8.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    d: "M5 17a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5V8.5H5zM16.55 17a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V8.5h1.5z"
  })));
};
export default SvgDesk;